module.exports = __webpack_public_path__ + "img/document-code.15a57d18.svg";